import React, { forwardRef, useImperativeHandle } from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

export const EnterpriseAuthentication = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  useImperativeHandle(ref, () => form);

  return (
    <Form form={form} labelAlign="left" layout="vertical">
      <Form.Item
        name="enterpriseCode"
        label={t("user.enterpriseCode") + "："}
        rules={[{ required: true, message: t("login.noEmpty") }]}
      >
        <Input autoComplete="enterpriseCode" placeholder={t("user.inputEnterpriseCode")} />
      </Form.Item>

      <Form.Item
        name="enterpriseName"
        label={t("user.enterpriseName") + "："}
        rules={[{ required: true, message: t("login.noEmpty") }]}
      >
        <Input autoComplete="enterpriseName" placeholder={t("user.inputEnterpriseName")} />
      </Form.Item>

      <Form.Item
        name="legalPersonName"
        label={t("user.legalPersonName") + "："}
        rules={[{ required: true, message: t("login.noEmpty") }]}
      >
        <Input autoComplete="legalPersonName" placeholder={t("user.inputLegalPersonName")} />
      </Form.Item>
    </Form>
  );
});
